import { privateClient } from "../../configs/axiosConfig";

const busyTimeEndpoints = {
  create: "/v2/busy-time", // Adjust path to your backend route
  getAll: "/v2/busy-time", // Optional, if listing is needed
  deleteBusy: "/v2/busy-time", // Optional, if listing is needed
};

const busyTimeApi = {
  createBusyTime: async (data) => {
    try {
      const response = await privateClient.post(busyTimeEndpoints.create, data);
      return { response };
    } catch (err) {
      console.error("❌ Error creating busy time:", err);
      return { err };
    }
  },

  getAllBusyTimes: async () => {
    try {
      const response = await privateClient.get(busyTimeEndpoints.getAll);
      return { response };
    } catch (err) {
      console.error("❌ Error fetching busy times:", err);
      return { err };
    }
  },

  deleteBusyTime: async (id) => {
    try {
      const url = `${busyTimeEndpoints.deleteBusy}/${id}`;
      const response = await privateClient.delete(url);
      return { response };
    } catch (err) {
      return { err };
    }
  },
};

export default busyTimeApi;
